import { render } from "./custom_messenger_fixed.vue?vue&type=template&id=06f3b15d&scoped=true"
import script from "./custom_messenger_fixed.vue?vue&type=script&lang=js"
export * from "./custom_messenger_fixed.vue?vue&type=script&lang=js"

import "./custom_messenger_fixed.vue?vue&type=style&index=0&id=06f3b15d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/smt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f3b15d"]])

export default __exports__